const privacyPDF = "/privacy.pdf";
const refundPDF = "/refund.pdf";
const tncPDF = "/tnc.pdf";
const fairpracticePDF = "/fairpractice.pdf";
const disclaimerPDF = "/disclaimer.pdf";

export const HEADING_BLANK = "";
export const HEADING_MAIL = "How do we mail you?";
export const HEADING_LOANSTATUS = "Loan Status";
export const HEADING_NOTIFICATION = "Notifications";
export const HEADING_APPLYLOAN = "Apply for a Loan";
export const HEADING_SIGNIN = "Sign In";
export const HEADING_KEYSTAT = "Key Facts Statement";
export const HEADING_CHANGE_MOBILE_NUMBER = "Change Your Mobile Number";
export const HEADING_AGREEMENT = "Agreements";
export const HEADING_ESIGN = "E-sign";
export const HEADING_FORG0TMPIN = "Forgot MPIN";
export const HEADING_RESETMPIN = "Reset MPIN";
export const HEADING_MANDATE = "Mandate Details";
export const HEADING_LOANDETAIL = "Loan Review";
export const HEADING_ASSIGNINGNBFC = "Assigning NBFC";
export const HEADING_NBFCASSIGNED = "NBFC Assigned";
export const HEADING_MANUALVERIFICATION = "KYC Verification";
export const HEADING_COMPLETEPROFILE = "Complete your profile";
export const BANK_STATEMENT = "Bank Statement";
export const HEADING_SECURITY_PRIVACY = "Security & Privacy";
export const HEADING_CHANGEMPIN = "Change your MPIN";
export const HEADING_RAISE_TICKET = "Raise a Ticket";
export const HEADING_TICKETHISTORY = "Ticket History";
export const HEADING_POLICIES = "Policies";
export const HEADING_LOANREPAY = "Loan Repayment";
export const HEADING_VERIFYOTP = "Verify your number!";
export const HEADING_EMAIL_VERIFYOTP = "Verify your E-mail!";
export const SAFETY_COVERAGE = "Safety Coverage";


export const HEADING_MPIN = "Let’s keep your account safe";
export const HEADING_CREDITLIMIT = "Basic Details";
export const HEADING_PAN = "Provide your PAN";
export const HEADING_VERIFYPANOTP = "Verify OTP";
export const HEADING_AADHAR = "Verify your Aadhaar";
export const HEADING_SELFIE = "Take a live selfie for more security";
export const WHATSAPPHEADING = "Verify WhatsApp Number"
export const HEADING_EMPLOYMENT = "Employment Details"

export const T_C_LINK = "https://www.paymeindia.in/terms";
export const REFUD_POLICY_LINK = "https://www.paymeindia.in/refund";
export const FAIR_PRACTICE_CODE =
  "https://www.paymeindia.in/fair-practice-code";
export const PRIVACY_POLICY_LINK = "https://www.paymeindia.in/privacy-policy";
export const DISCLAIMER_LINK = "https://www.paymeindia.in/disclaimer";

export const GRIEVANCE_REDRESSAL_MECHANISM_LINK = "https://openscecurityurl.s3.ap-south-1.amazonaws.com/NewAppAgreeDocs/grievance_redressal_mechanism.pdf";


const SUPPORT_CHAT_BOT = process.env.REACT_APP_MIXPANEL_TOKEN;
export const payme_initial_token = SUPPORT_CHAT_BOT;

export const PRIVACY_POLICY_PDF = privacyPDF;
export const REFUND_POLICY_PDF = refundPDF;
export const T_C_PDF = process.env.REACT_APP_T_C;
export const FAIR_PRACTICE_CODE_PDF = fairpracticePDF;
export const DISCLAIMER_PDF = disclaimerPDF;

